import RequestForm from "../../../subComponent/RequestForm";
import Footer from "../../../subComponent/Footer";

const PartnerProgram = () => {
    return (
        <>
            <div className="bg-white">
                <div className="row">
                    <div className=" col-12  background-setting bespoke-banner p-0">
                        <div className="bespoke-section">
                            <div className="inventory-backdrop p-0" >
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Join Us As A Partner Now</p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-12 col-md-11 background-setting build-partner-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before text-white fs_19">Partner Programs </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">

                                    <p className="sales-text text-white fs_32 poppins m-0 pb-4 ">Build LastingPartners</p>
                                    <p className="sales-text text-white fs_19 poppins m-0 pb-4 ">At SmartB, we work with Partners so that we can grow together. Whether you are new to reselling or a seasoned System Integrator, we look forward to a positive partnership. So get in touch with us today.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>

                    <div className="col-12 col-md-1">
                    </div>
                    <div className=" col-12 col-md-11 background-setting partnership-program-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before line-after text-white fs_19">Partner Programs </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="  text-end text-white fs_32 poppins m-0 pb-5 ">Partnership Programst</p>
                                    <p className=" text-end text-white poppins m-0 ls_2 fs_19 pb-5 ">We are constantly growing both organically and through our partner network. Feel free to contact us to discuss how we can create a win-win-win partnership.</p>
                                    <p className=" text-end text-white poppins m-0 ls_2 fs_19 pb-5 ">Today, the type of partnerships include:</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="  col-12 col-md-4  background-setting referral-backgroud p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="bespoke-section">
                                <p className=" bespoke-text text-center text-white fs_56 poppins py-3 ">1</p>
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Referral Partners</p>
                                <p className=" bespoke-text text-center text-white fs_14 poppins py-3 ">You bring us the clients and we’ll do the rest. Once we get paid, we’ll share the referral.</p>
                            </div>
                        </div>
                    </div>
                    <div className="  col-12 col-md-4  background-setting project-partner-background p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="bespoke-section">
                                <p className=" bespoke-text text-center text-white fs_56 poppins py-3 ">2</p>
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Project Partners</p>
                                <p className=" bespoke-text text-center text-white fs_14 poppins py-3 ">You bring the clients and help project manage the clients.</p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-12 col-md-4 background-setting label-white-background p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="bespoke-section">
                                <p className=" bespoke-text text-center text-white fs_56 poppins py-3 ">3</p>
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">OEM or White Label</p>
                                <p className=" bespoke-text text-center text-white fs_14 poppins py-3 ">We’ll build the system and maintain it for you, using your brand</p>
                            </div>
                        </div>
                    </div>

                    <div className="py-5">

                        <RequestForm />
                    </div>

                </div>
                <div className="background-setting bg-black py-5">
                    <Footer />
                </div>
            </div>

        </>
    );
}

export default PartnerProgram;